import { render } from "./ContentPage.vue?vue&type=template&id=5ace6c70&scoped=true"
import script from "./ContentPage.vue?vue&type=script&lang=js"
export * from "./ContentPage.vue?vue&type=script&lang=js"

import "./ContentPage.vue?vue&type=style&index=0&id=5ace6c70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ace6c70"]])

export default __exports__